var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8787 10.7166L7.76445 0.423529C7.42178 -0.141176 6.57854 -0.141176 6.23588 0.423529L0.121585 10.7166C-0.221083 11.2813 0.200635 12 0.885778 12H13.088C13.7998 12 14.2214 11.2813 13.8789 10.7166H13.8787ZM6.84203 3.58075C7.21099 3.47815 7.57997 3.65774 7.73805 4.01709C7.79081 4.14547 7.8171 4.27385 7.79081 4.40204C7.76452 4.787 7.73805 5.14634 7.71176 5.5315C7.68547 6.12183 7.63271 6.71234 7.60642 7.30267C7.60642 7.48244 7.58013 7.66202 7.58013 7.8418C7.55384 8.14976 7.31651 8.4065 7.00033 8.4065C6.68415 8.4065 6.44679 8.17553 6.42053 7.86738C6.36776 6.96889 6.31519 6.04482 6.26242 5.14656C6.23614 4.88981 6.23614 4.65882 6.20966 4.40227C6.23595 3.99154 6.4731 3.65779 6.84208 3.58079L6.84203 3.58075ZM7.02661 10.4086C6.60489 10.4086 6.26241 10.0748 6.26241 9.63846C6.26241 9.22772 6.60508 8.89416 7.0531 8.89416C7.47482 8.89416 7.8173 9.25351 7.8173 9.66426C7.79082 10.0748 7.44834 10.4342 7.02661 10.4086Z",
    fill: "#FD5B5B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.582f57b8ec7a7e63852df96dec82d21d.svg";
export { ForwardRef as ReactComponent };